
        var result = require("!!../../../../../node_modules/css-loader/index.js!./navigation.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/navigation/navigation.component.css
// module id = 1535
// module chunks = 0